export default __webpack_public_path__ + "media/src/assets/images/adjust-5b7773987072cfdb700818868fc200b3.png";